import { generateSeoProps } from '../generateSeoProps';

export const getAssessmentsProps = () => {
    return generateSeoProps({
        title: 'Pharmuni Assessments: Free GMP & Pharmacovigilance Tests',
        canonical: 'assessments',
        noIndex: false,
        description: `Explore pharma assessments: GMP and Pharmacovigilance. Take a timed quiz, get your score, benchmark, and course recommendations. Create a free account to start.`,
    });
};

export const getMyAssessmentsProps = () => {
    return generateSeoProps({
        title: 'My Assessments: Scores, History & Recommendations | Pharmuni',
        canonical: 'my-assessments',
        noIndex: false,
        description: `Review your assessment scores by topic, track best score and past attempts, and follow recommended courses to close skill gaps in GMP, PV, QA, and more.`,
    });
};

export const getAssessmentsResultProps = ({ title = '' }) => {
    return generateSeoProps({
        title: title + ' Results' ,
        noIndex: false,
        description: `Results for the ${title} assessment. Review your score, performance by category, and get personalized course recommendations to improve your skills.`,
    });
};

export const getAssessmentDynamicProps = ({ title = '', description = '', id = '', slug = '', image = '' }) => {
    return generateSeoProps({
        title: `${title} - Pharmuni Assessments`,
        description: description,
        canonical: `assessments/${id}/${slug}`,
        noIndex: false,
        image: image
    });
};